import { ErrorHandler, Injectable } from '@angular/core';
import { TelemetryService } from './telemetry.service';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private readonly telemetryService: TelemetryService) {}

  handleError(error: unknown): void {
    this.telemetryService.trackException(error, {
      source: 'GlobalErrorHandler',
    });
  }
}

